import React, { useCallback, useContext, useEffect, useRef } from 'react';
import { useLocalStorage } from 'usehooks-ts';
import { useCreatePunchOutRequestMutation } from '../../redux/api/punchoutApi';
import { Alert, Container, ThemeProvider } from '@mui/material';
import WholePageSpinner from '../../common/WholePageSpinner';
import { getError } from '../../helpers/checkout';
import { AuthContext } from '../../common/Auth';
import { useThemeSettings } from '../../layouts/state/useThemeSettings';
import { newTheme } from '../../components/theme/theme';

export default function PunchOutForm() {
  const [sessionId, _, removeSessionId] = useLocalStorage<string>(
    'punch-out-session',
    '',
    { deserializer: (value) => value || '' },
  );

  const { settingData } = useContext(AuthContext);
  const { themedefaultColor, themedefaultTextColor, defaultFont } = useThemeSettings({
    settingData,
  });

  const [createPunchOutOrder, { data, isLoading, error }] = useCreatePunchOutRequestMutation();

  const refCallback = useCallback((node: HTMLFormElement | null) => {
    if (!node) return;
    node.submit();
  }, []);

  useEffect(() => {
    if (!sessionId) return;
    const createOrder = async () => {
      try {
        await createPunchOutOrder({ sessionId }).unwrap();
        removeSessionId();
      } catch (error) {
        console.error('Error creating punch out order:', error);
      }
    }
    createOrder();
  }, [createPunchOutOrder, removeSessionId, sessionId]);

  return (
    <ThemeProvider
      theme={newTheme({ themedefaultColor, themedefaultTextColor, fontFamily: defaultFont })}
    >
      <Container>
        {error && <Alert severity="error">{getError(error)}</Alert>}
        {isLoading && <WholePageSpinner text="Creating Punch Out Order " />}
        {data && (
          <form ref={refCallback} action={data.to} method="POST">
            <input type="hidden" name="cxml-base64" value={data.orderMsg} />
          </form>
        )}
      </Container>
    </ThemeProvider>
  );
}
